import { useState } from "react";
import axios from "axios";
import { API, getAuthHeader } from "@/App";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Coffee, Phone, PackageX, Utensils, Users, PenLine } from "lucide-react";

const OPTS = [
  ["Waiting stock", PackageX], ["On call", Phone], ["Break", Coffee],
  ["Lunch", Utensils], ["Meeting", Users], ["Other", PenLine],
];

// ref = { email, name, invoice_no, customer_name, at? , date? }
export const IdleReasonDialog = ({ idleRef, onClose, onSaved }) => {
  const [other, setOther] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async (reason) => {
    setBusy(true);
    try {
      await axios.post(`${API}/reports/work-timeline/idle-reason`, { ...idleRef, reason, note: reason === "Other" ? note : "" },
        { headers: getAuthHeader() });
      toast.success(`Idle reason saved: ${reason}`);
      setOther(false); setNote("");
      onSaved?.(reason); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save reason"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!idleRef} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="idle-reason-dialog">
        <DialogHeader><DialogTitle>Why was this parcel idle?</DialogTitle></DialogHeader>
        {idleRef && <p className="text-xs text-slate-600 -mt-2">{idleRef.name || idleRef.email} · <b>{idleRef.customer_name}</b> · Invoice {idleRef.invoice_no}</p>}
        <div className="grid grid-cols-3 gap-2">
          {OPTS.map(([r, Icon]) => (
            <button key={r} type="button" disabled={busy} data-testid={`idle-reason-${r.replace(/\s/g, "-").toLowerCase()}`}
              onClick={() => (r === "Other" ? setOther(true) : save(r))}
              className={`flex flex-col items-center gap-1 rounded-xl border px-2 py-3 text-xs font-semibold hover:bg-amber-50 hover:border-amber-300 ${other && r === "Other" ? "bg-amber-50 border-amber-400" : "border-slate-200"}`}>
              <Icon className="w-4 h-4 text-amber-600" />{r}
            </button>
          ))}
        </div>
        {other && (
          <div className="flex gap-2">
            <input autoFocus value={note} onChange={e => setNote(e.target.value)} placeholder="Short note" maxLength={200}
              className="flex-1 px-2 py-1.5 border border-slate-300 rounded-lg text-sm" data-testid="idle-reason-note"
              onKeyDown={e => e.key === "Enter" && note.trim() && save("Other")} />
            <button onClick={() => save("Other")} disabled={busy || !note.trim()} data-testid="idle-reason-other-save"
              className="px-3 py-1.5 rounded-lg bg-amber-600 text-white text-sm font-semibold disabled:opacity-50">Save</button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
